function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "chevron-compare-left_svg__a",
  d: "M-2.598 5.77L9.186 17.808 21.087 5.862 24.231 9.1 9.159 24.231-5.769 8.978z"
}));

var _ref2 = /*#__PURE__*/React.createElement("use", {
  fillRule: "nonzero",
  transform: "matrix(0 -1 -1 0 24.23 24.23)",
  xlinkHref: "#chevron-compare-left_svg__a"
});

function SvgChevronCompareLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}

export default SvgChevronCompareLeft;